// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__gVgtd","lastLink":"HeadPage_lastLink__M9S09"};